import { createContext, useContext } from 'react';
import type { PublicPagePayload } from '@/hooks/storefront/useStorefrontApi';

export interface StorePageContextValue {
  page: PublicPagePayload | null;
  /** Préfixe des liens internes de l'entrée courante (ex. /shop/ma-boutique). */
  basePath: string;
  currency: string;
  restaurantMode: boolean;
  restaurantThemeMode: 'dark' | 'light';
  toggleRestaurantThemeMode: () => void;
  setContext: (value: { page: PublicPagePayload | null; basePath: string }) => void;
}

export const StorePageContext = createContext<StorePageContextValue | null>(null);

export function useStorePageContext(): StorePageContextValue {
  const context = useContext(StorePageContext);
  return (
    context ?? {
      page: null,
      basePath: '',
      currency: 'XOF',
      restaurantMode: false,
      restaurantThemeMode: 'light',
      toggleRestaurantThemeMode: () => {},
      setContext: () => {},
    }
  );
}
